// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1Vuzt","infoBtn":"quickbooks_infoBtn__gIny-","formBox":"quickbooks_formBox__1hOt0","formFooter":"quickbooks_formFooter__2IREv"};